/** Erro de API com o corpo já decodificado (o backend devolve {erro, mensagem, detalhes}). */
export class ErroApi extends Error {
  constructor(status, corpo) {
    super(corpo?.mensagem ?? `Erro ${status}`)
    this.name = 'ErroApi'
    this.status = status
    this.codigo = corpo?.erro ?? 'desconhecido'
    this.detalhes = corpo?.detalhes ?? null
  }
}

/** Falha de rede — o que a fila offline precisa distinguir de um 4xx do servidor. */
export class ErroRede extends Error {
  constructor() {
    super('Sem conexão com o servidor.')
    this.name = 'ErroRede'
  }
}

async function pedir(metodo, caminho, corpo) {
  let resposta
  try {
    resposta = await fetch(`/api${caminho}`, {
      method: metodo,
      // O cookie de sessão é httpOnly: nada de token no JavaScript.
      credentials: 'same-origin',
      headers: corpo === undefined ? {} : { 'Content-Type': 'application/json' },
      body: corpo === undefined ? undefined : JSON.stringify(corpo),
    })
  } catch {
    throw new ErroRede()
  }

  const dados = await resposta.json().catch(() => null)
  if (!resposta.ok) throw new ErroApi(resposta.status, dados)
  return dados
}

export const api = {
  get: (caminho) => pedir('GET', caminho),
  post: (caminho, corpo) => pedir('POST', caminho, corpo ?? {}),
  patch: (caminho, corpo) => pedir('PATCH', caminho, corpo ?? {}),
  put: (caminho, corpo) => pedir('PUT', caminho, corpo ?? {}),
  remover: (caminho, corpo) => pedir('DELETE', caminho, corpo),
}

/** Monta query string ignorando valores vazios. */
export function query(parametros) {
  const busca = new URLSearchParams()
  for (const [chave, valor] of Object.entries(parametros)) {
    if (valor !== null && valor !== undefined && valor !== '') busca.set(chave, valor)
  }
  const texto = busca.toString()
  return texto ? `?${texto}` : ''
}
